<template>
  <div class="part4">
    <div class="part4box">
      <div class="gift_content dl">
        <div
          class="gift_item pr"
          v-for="(item, index) in giftList"
          :key="'item' + index"
        >
          <img
            :src="item.img"
            alt=""
            class="gift_item_img itemPrize"
            @click="treasureBox3(index)"
            v-show="item.show"
          />
          <img
            :src="item.img2"
            alt=""
            class="treasureBox"
            v-show="!item.show"
            @click="treasureBox3(index)"
          />
          <!-- :class="{ giftyao: peopleNum === 5 }" -->
          <p class="gift_text">{{ item.text }}</p>
        </div>
      </div>
      <div class="progress pa">
        <!-- <div class="progress0 bg pa"></div> -->
        <div
          class="progress100 bg pa"
          :style="`clip-path: inset(0 ${progressNum} 0 0);`"
        ></div>
      </div>
      <div class="head_portrait pa dl">
        <div
          class="head_item"
          v-for="(item, index) in inviteCount"
          :key="index"
        >
          <img
            src="@/assets/images/page4/invites.png"
            alt="头像"
            class="headitem_img1"
          />
          <img
            src="@/assets/images/page4/role.png"
            alt=""
            class="headitem_img2"
            v-if="item.status"
          />
        </div>
      </div>
      <div class="bigBtn dl">
        <!-- <p class="st">开始修炼</p> -->
        <!-- <p class="st"> -->
        <img
          class="st"
          src="@/assets/images/page4/invitefriends.png"
          alt=""
          @click="openAlert()"
        />
        <!-- </p> -->
        <!-- <a href="#" class="gamerule">活动规则</a> -->
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { share } from "@/js/api";
export default {
  name: "pageFour",
  props: ["allCode"],
  data() {
    return {
      // peopleNum: 1,
      peopleNum: this.allCode.inviteCount,
      rem: "",
      giftList: [
        {
          value: 5,
          text: "邀請5人",
          img: require("@/assets/images/page4/item3.png"),
          img2: require("@/assets/images/page4/5.png"),
          show: false,
        },
        {
          value: 3,
          text: "邀請3人",
          img: require("@/assets/images/page4/item2.png"),
          img2: require("@/assets/images/page4/3.png"),
          show: false,
        },
        {
          value: 1,
          text: "邀請1人",
          img: require("@/assets/images/page4/item1.png"),
          img2: require("@/assets/images/page4/1.png"),
          show: false,
        },
      ],
      inviteCount: [
        {
          img1: require("@/assets/images/page4/invites.png"),
          img2: require("@/assets/images/page4/role.png"),
        },
        {
          img1: require("@/assets/images/page4/invites.png"),
          img2: require("@/assets/images/page4/role.png"),
        },
        {
          img1: require("@/assets/images/page4/invites.png"),
          img2: require("@/assets/images/page4/role.png"),
        },
        {
          img1: require("@/assets/images/page4/invites.png"),
          img2: require("@/assets/images/page4/role.png"),
        },
        {
          img1: require("@/assets/images/page4/invites.png"),
          img2: require("@/assets/images/page4/role.png"),
        },
      ],
      // conbox: false,
      codePage: "",
      treasure1: false,
      treasure2: false,
      treasure3: false,
      tagid: "",
    };
  },
  mounted() {
    let dox = document.documentElement.style.fontSize;
    this.rem = dox.slice(0, dox.length - 2);
    // this.isInvite();
    this.$bus.$on("point3", () => {
      this.anchor();
    });
    this.$nextTick(() => {
      this.$on("pagefour", (res, res2) => {
        this.tagid = res2;
        this.inviteCount.forEach((itme, index) => {
          if (res >= index + 1) {
            this.$set(this.inviteCount[index], "status", true);
          }
        });
      });
    });
  },
  methods: {
    treasureBox3(index) {
      this.giftList[index].show = !this.giftList[index].show;
    },
    openAlert() {
      this.$bus.$emit("tips", "活動已結束，請到商店下載體驗");
      // // let that = this;
      // let phoneData = this.$util.getToken();
      // if (phoneData) {
      //   this.$bus.$emit("inviteSC");
      // } else {
      //   // alert("請先完成預約再進行邀請");
      //   this.$bus.$emit("tips", "請先完成預約再進行邀請");
      // }
    },
    //定位
    anchor() {
      let ele = document.getElementsByClassName("part4")[0];
      let eletop = ele.offsetTop;
      window.scrollTo({
        top: eletop,
        behavior: "smooth",
      });
    },
    // mouseover(e) {
    //   if (this.conbox) {
    //     this.conbox = false;
    //   }
    //   setTimeout(() => {
    //     this.conbox = true;
    //     let box = document.getElementsByClassName("Bubble")[0];
    //     box.style.left = Math.floor(e.x / Number(this.rem)) + "rem";
    //   }, 100);
    // },
    // mouseout() {
    //   this.conbox = false;
    // },
  },
  computed: {
    progressNum() {
      let maxNum = this.giftList[0].value;
      let precent = Math.floor((this.peopleNum / maxNum) * 100);
      precent = precent > 100 ? 100 : precent;
      return 100 - precent + "%";
    },
  },
};
</script>

<style lang="less" scoped>
@keyframes popover {
  0% {
    opacity: 0;
    scale: 0;
    top: 1.5rem;
  }
  100% {
    opacity: 1;
    scale: 1;
    top: 0.8rem;
  }
}
.part4 {
  width: 100%;
  z-index: 8;
  .part4box {
    height: 13rem;
    position: relative;
    .Bubble {
      top: 0.8rem;
      left: 0;
      font-size: 0.2rem;
      border: 1px solid #000;
      border-radius: 0.05rem;
      background: skyblue;
      padding: 0.15rem;
      animation: popover 0.3s ease-in-out;
      &::before {
        content: "";
        content: "";
        width: 0;
        height: 0;
        border-top: 0.1rem solid skyblue;
        border-right: 0.1rem solid transparent;
        border-left: 0.1rem solid transparent;
        bottom: -0.1rem;
        left: 40%;
        position: absolute;
        z-index: 2;
      }
      &::after {
        content: "";
        width: 0;
        height: 0;
        border-top: 0.1rem solid #000;
        border-right: 0.1rem solid transparent;
        border-left: 0.1rem solid transparent;
        bottom: -0.11rem;
        left: 40%;
        position: absolute;
        z-index: 1;
      }
    }
    .gift_content {
      justify-content: space-between;
      flex-direction: row-reverse;
      padding-left: 1.5rem;
      top: 4rem;
      padding-top: 4rem;
      .gift_item {
        z-index: 99;
        width: 1.8rem;
        height: 1.9rem;
        flex: 0 0 30%;
        &:nth-of-type(0) {
          margin-left: 0.3rem;
        }
      }
      .gift_item_img {
        width: 1.8rem;
        height: 1.9rem;
        cursor: pointer;
      }
      .treasureBox {
        width: 1.8rem;
        height: 1.5rem;
        cursor: pointer;
      }
      .itemPrize {
        transform: translate(-10px, -15px);
      }
      .gift_text {
        font-size: 0.25rem;
        width: 85%;
        text-align: center;
        color: #fff;
        font-weight: 600;
        font-family: Medium;
        position: absolute;
        bottom: 0;
      }
    }
    .progress {
      width: 100%;
      height: 1rem;
      position: absolute;
      top: 4.2rem;
      // .progress0 {
      //   width: 100%;
      //   height: 100%;
      //   background-image: url("@/assets/images/page4/progress0.png");
      //   background-size: 100%;
      //   background-position-x: -0.7rem;
      //   transform: scale(1.2);
      // }
      .progress100 {
        width: 100%;
        height: 100%;
        background-image: url("@/assets/images/page4/progress100.png");
        background-size: 85.5%;
        clip-path: inset(0 50% 0 0);
        background-position: 1rem 0.13rem;
      }
    }
    .head_portrait {
      bottom: 2rem;
      width: 100%;
      justify-content: center;
      display: flex;
      gap: 0.2rem;
      .head_item {
        position: relative;
        flex: 0 0 15%;
        .headitem_img1 {
          width: 100%;
          transform: scale(1.2);
        }
        .headitem_img2 {
          width: 100%;
          position: absolute;
          bottom: 0.2rem;
          left: 0;
          transform: scale(0.8);
        }
      }
    }
    .bigBtn {
      position: absolute;
      bottom: 0rem;
      left: 50%;
      transform: translateX(-50%);
      cursor: pointer;
      .st {
        width: 4.4rem;
      }
      .gamerule {
        position: absolute;
        color: #000;
        right: -1.2rem;
        top: 35%;
        font-size: 0.2rem;
      }
    }
  }
}
@media screen and (max-width: 410px) {
  .part4 {
    .part4box {
      .progress {
        .progress100 {
          background-position: 1rem 0rem;
        }
      }
    }
  }
}
// @keyframes boxMove {
//   0%,
//   39%,
//   50%,
//   61%,
//   100% {
//     transform: translateX(0);
//   }
//   40%,
//   60% {
//     transform: translateX(10px) rotateZ(4deg);
//   }
//   45%,
//   55% {
//     transform: translateX(-10px) rotateZ(-4deg);
//   }
// }
</style>